// videocards strings (en).
const videocards = {
	videocards: {
		// ===== List page (index.tsx) =====
		helmetList: 'Video Cards | CardClan',
		helmetDetails: 'Video Card Details | CardClan',
		backToVideoCards: 'Back to Video Cards',
		title: 'Video Cards',
		subtitle: 'Create and manage video greeting cards',
		createVideoCard: 'Create Video Card',

		// Upgraded success banner
		bannerStackAdded: 'stack added',
		bannerActivated: 'activated',
		upgradedBanner: 'Lifetime Deal %{state}! You now have %{cards} video cards and %{minutes} render minutes per month.',

		// Workspace disabled
		workspaceDisabledAlert: 'Video cards are disabled for this workspace. Contact your workspace admin.',
		workspaceDisabledBanner: 'Video cards are disabled for this workspace. Contact your workspace admin to enable them.',

		// Get Started modal
		getStartedTitle: 'Get Started',
		getStartedSubtitle: 'Set up your video card board.',
		occasionLabel: 'Occasion',
		occasionPlaceholder: 'Type or select an occasion...',
		loading: 'Loading...',
		noMatchEnter: 'No match — press Enter to use "%{input}"',
		noCategories: 'No categories found',
		recipientFirstName: 'Recipient First Name',
		firstNamePlaceholder: 'e.g. Sarah',
		lastName: 'Last Name',
		lastNamePlaceholder: 'Optional',
		boardTitle: 'Board Title',
		boardTitlePlaceholder: 'Auto-generated from occasion & name',
		themePreview: 'Theme: %{occasion} — %{font}',
		cancel: 'Cancel',
		creating: 'Creating...',
		createBoard: 'Create Board',

		// Auto-generated titles / fallbacks
		autoTitleHappyOccasionName: 'Happy %{occasion} %{name}!',
		autoTitleHappyOccasion: 'Happy %{occasion}!',
		autoTitleForName: 'For %{name}',
		untitledVideoCard: 'Untitled Video Card',

		// ===== Cards list (VideoCardsList.tsx) =====
		deleteConfirmTitle: 'Delete Video Card?',
		deleteConfirmText: 'This will permanently delete this video card and all its submissions.',
		delete: 'Delete',
		noVideoCardsYet: 'No video cards yet',
		createFirstVideoCard: 'Create your first video card to get started',
		videoCardBadge: 'Video Card',
		copied: 'Copied!',
		copyInviteLink: 'Copy Invite Link',
		due: 'Due: %{date}',

		// ===== Usage bar (VideoCardUsageBar.tsx) =====
		progressVideoCards: 'Video Cards',
		progressRenderMinutes: 'Render Minutes',
		tierFree: 'Free',
		tierLtd: 'Lifetime Deal',
		upgrade: 'Upgrade',
		stackMore: 'Stack More',

		// ===== Detail (VideoCardDetail.tsx) =====
		detailHelmetFallback: 'Video Card',
		statusSent: 'Sent',
		statusProcessing: 'Processing',
		statusScheduled: 'Scheduled',
		statusDraft: 'Draft',
		tileSingular: 'tile',
		tilePlural: 'tiles',
		submissionSingular: 'submission',
		submissionPlural: 'submissions',
		editBoard: 'Edit Board',
		deliveryModeVideo: 'Video',
		deliveryModeBoard: 'Board',
		preview: 'Preview %{mode}',
		sentNoEdit: 'This card has been sent and can no longer be edited.',
		scheduledForPrefix: 'Scheduled for',
		futureDate: 'a future date',
		atLabel: 'at',
		cancelSchedule: 'Cancel Schedule',

		// Tabs
		tabContent: 'Content & Render',
		tabSettings: 'Settings',
		tabDelivery: 'Delivery',

		// Content & render
		latestRenderedVideo: 'Latest rendered video',
		reRender: 'Re-render',
		downloadMp4: 'Download MP4',
		renderingFailed: 'Rendering failed. Please try again.',
		renderVideo: 'Render Video',
		boardTilesHeading: 'Board Tiles (%{count})',
		tileBreakdown: '%{videos} videos, %{texts} texts, %{images} images, %{gifs} GIFs.',
		dragToReorderTiles: ' Drag to reorder.',
		noBoardTiles: 'No board tiles yet. Open the editor or share the invite link.',
		videoBadge: 'Video',
		creator: 'Creator',
		videoSubmissionsHeading: 'Video Submissions (%{count})',
		dragReorderRenderSeq: 'Drag to reorder. Order determines render sequence.',

		// Render steps & errors
		stepExporting: 'Exporting page snapshots...',
		stepStarting: 'Starting render...',
		stepQueued: 'Queued...',
		stepProcessing: 'Processing... %{progress}%',
		errRenderingFailed: 'Rendering failed',
		errLostConnection: 'Lost connection to render progress',
		errTimeout: 'Render timed out after 10 minutes',
		errRenderLimit: 'Render limit reached. Upgrade your plan for more render minutes.',
		errFailedStart: 'Failed to start render',

		// Save / status messages
		saved: 'Saved!',
		failedToSave: 'Failed to save',
		scheduleCancelled: 'Schedule cancelled',
		selectFutureDate: 'Please select a future date and time',
		enterRecipientEmail: 'Please enter a recipient email',
		scheduledMsg: 'Scheduled!',

		// Settings tab
		contributionSettings: 'Contribution Settings',
		submissionDeadline: 'Submission Deadline',
		submissionDeadlineHint: 'After this date, contributors can no longer add content',
		maxClipDuration: 'Max Clip Duration',
		maxClipDurationHint: "Maximum length for each contributor's video clip",
		inviteMessage: 'Invite Message',
		inviteMessageHint: 'Custom message shown to contributors on the board page',
		inviteMessagePlaceholder: 'e.g. Record a birthday message for Sarah!',
		deliveryFormat: 'Delivery Format',
		deliveryFormatHint: 'How should the recipient view this card?',
		interactiveBoard: 'Interactive Board',
		interactiveBoardHint: 'Recipient sees the live tile board with effects',
		renderedVideo: 'Rendered Video',
		renderedVideoHint: 'Recipient receives an MP4 video compilation',
		saving: 'Saving...',
		saveSettings: 'Save Settings',

		// Delivery tab
		cardSent: 'Card Sent',
		cardDeliveredTo: 'This card has been delivered to %{recipient}.',
		theRecipient: 'the recipient',
		senderEmail: 'Sender Email',
		sendFrom: 'Send from',
		defaultCardClan: 'Default (CardClan)',
		senderEmailHint: 'Choose which email address the card will be sent from.',
		recipient: 'Recipient',
		emailLabel: 'Email',
		nameLabel: 'Name',
		recipientNamePlaceholder: "Recipient's name",
		schedule: 'Schedule',
		sendDateTime: 'Send Date & Time',
		sendDateTimeHint: 'Choose when to deliver the card. Leave empty to send manually.',
		autoRenderSend: 'Auto-render & send at scheduled time',
		autoRenderSendHint: 'The video will be automatically rendered and emailed when the time comes.',
		autoRenderSendTag: '(auto-render & send)',
		shareLinks: 'Share Links',
		inviteContributors: 'Invite Contributors',
		viewCardLabel: 'View Card',
		copy: 'Copy',
		scheduling: 'Scheduling...',
		scheduleSend: 'Schedule Send',
		save: 'Save',
		sending: 'Sending...',
		sendNow: 'Send Now',
		sentSuccessfully: 'Sent successfully!',
		failedToSend: 'Failed to send. Please try again.',

		// ===== Upgrade (VideoCardsUpgrade.tsx) =====
		upgradeHelmet: 'Upgrade Video Cards | CardClan',
		limitedTimeOffer: 'Limited Time Offer',
		upgradeIntro: 'Take your celebrations to the next level with rendered video cards. Due to compute costs, video rendering has usage limits.',
		planFree: 'Free',
		foreverFree: 'Forever free',
		free2Cards: '2 video cards / month',
		board10Items: '10 board items / card',
		free20Min: '20 rendered minutes / month',
		currentPlan: 'Current Plan',
		freeTier: 'Free Tier',
		lifetimeDeal: 'Lifetime Deal',
		perStack: '/ stack',
		oneTimePayment: 'One-time payment, stack up to %{max}x',
		currentPlanBadge: 'CURRENT PLAN',
		bestValue: 'BEST VALUE',
		stackSingular: 'stack',
		stackPlural: 'stacks',
		yourCurrentPlan: 'Your current plan (%{count}x %{stacks})',
		planLimits: '%{cards} video cards / month · %{minutes} render min / month',
		ltdCardsPerStack: 'video cards / month per stack',
		ltdMinutesPerStack: 'rendered minutes / month per stack',
		benefitNoFees: 'No recurring fees',
		benefitLifetime: 'Lifetime access',
		benefitPriority: 'Priority rendering',
		benefitEarly: 'Early adopter pricing',
		addStacksLabel: 'Add stacks:',
		stacksLabel: 'Stacks:',
		maxMore: '(max %{count} more)',
		afterPurchase: "After purchase you'll have:",
		processing: 'Processing...',
		addStacksBtnSingular: 'Add %{count} Stack',
		addStacksBtnPlural: 'Add %{count} Stacks',
		getStacksBtnSingular: 'Get %{count} Stack',
		getStacksBtnPlural: 'Get %{count} Stacks',
		maxStacksReached: 'Maximum stacks reached (%{count}/%{max})',
	},
};
export default videocards;
